import script from "./ROIReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ROIReport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QDrawer,QScrollArea,QDate,QBtnToggle,QSelect,QPageContainer,QPage,QTable,QTd,QTr,QBanner});
